import type { MiniAppReportRequest } from '@exam-prep/contracts';
import { useState } from 'react';
import { api } from '../../../lib/api';

/** Sends "Report a problem" for one question; remembers which questions were already reported. */
export function useReportQuestion(attemptId: string) {
  const [sent, setSent] = useState<ReadonlySet<string>>(new Set());
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const send = async (itemId: string, reason: MiniAppReportRequest['reason'], note: string) => {
    setBusy(true);
    setFailed(false);
    try {
      const body: MiniAppReportRequest = {
        itemId,
        reason,
        ...(note.trim() ? { note: note.trim() } : {}),
      };
      await api('POST', `/app/attempts/${attemptId}/report`, body);
      setSent((s) => new Set(s).add(itemId));
      return true;
    } catch {
      setFailed(true);
      return false;
    } finally {
      setBusy(false);
    }
  };
  return { sent, busy, failed, send };
}
